import React, { Component, useEffect, useState } from 'react'
import styled from 'styled-components'
import { isMobile, isTablet } from 'react-device-detect'
import moment from 'moment'
import { Modal } from 'react-responsive-modal'

import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import GenericLogo from '../../GenericComponents/GenericLogo'
import GenericRow from '../../GenericComponents/GenericRow'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericCloseButton from '../../GenericComponents/GenericCloseButton'
import GenericCard from '../../GenericComponents/GenericMainCard'
import {
  SUB_container,
  SUB_tile,
  SUB_ball,
  PromoInfo,
} from './style/SelectSubscriptionPlanScreenStyle'

import { SubCheckboxContainer } from './SelectSubscriptionPlanScreen.jsx'
import Checkbox from '@material-ui/core/Checkbox'
import {
  CheckboxContainer,
  CustomCheckedIcon,
  CustomUncheckedIcon,
} from '../AddUserScreen/AddUser.jsx'

import { BsArrowLeftShort, BsCheck, BsX } from 'react-icons/bs'
import GenericColumn from '../../GenericComponents/GenericColumn'
import GenericButton from '../../GenericComponents/GenericButton'
import GenericCheckbox from '../../GenericComponents/GenericCheckbox'
import {
  AvailablePaymentMethods,
  TextColumn,
  PaymentMethodIcon,
} from './SelectSubscriptionPlanScreen.jsx'
import Nutshell from './subComponents/nutshell'

import americanExpressIcon from '../../assets/choseSubscriptionPlan/americanExpressIcon4.png'
import googlePayIcon from '../../assets/choseSubscriptionPlan/googlePayIcon2.png'
import masterCardIcon from '../../assets/choseSubscriptionPlan/masterCardIcon2.png'
import przelewy24Icon from '../../assets/choseSubscriptionPlan/przelewy24Icon.png'
import visaIcon from '../../assets/choseSubscriptionPlan/visaIcon2.png'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { withTheme } from '@material-ui/core'

interface SelectSubProps {
  isUserReminded: boolean
  isUserCheckedLegalRegulationsChheckbox: boolean
  onCheckLegalCheckbox: Function
  onSelectSubscription: Function
  history: any
  handleTryApp: Function
  mode: string
  promoInfo: any
  isNutshell: boolean
  nutshellVersion: any
}

// const box =
//   document.getElementById('secondTile') && document.getElementById('secondTile')

// if (box) {
//   const rect = box.getBoundingClientRect()

//   const result = isInViewport(box)

//   console.log(result)
// }

function isInViewport(element: any) {
  const rect = element.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

const SelectSub = ({
  isUserReminded,
  isUserCheckedLegalRegulationsChheckbox,
  onCheckLegalCheckbox,
  onSelectSubscription,
  history,
  handleTryApp,
  mode,
  promoInfo,
  isNutshell,
  nutshellVersion,
}: SelectSubProps) => {
  const [isFirstActive, setIsFirstActive] = React.useState(true)
  const [isInfoOpen, setInfoOpen] = React.useState(false)
  const [isModalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    const scrollElement = document.getElementById('scrollElement')
    if (scrollElement) {
      scrollElement.addEventListener('scroll', () => {
        const screenPosition = document
          .getElementById('secondTile')
          .getBoundingClientRect()

        // console.log(screenPosition)

        if (screenPosition.x < 200) {
          setIsFirstActive(false)
        } else {
          setIsFirstActive(true)
        }
      })
    }
  }, [])

  const handleScrollToPart = (part: string) => {
    // document.getElementById('scrollElement').scrollLeft = 200

    if (part == 'second') {
      document.getElementById('scrollElement').scrollTo({
        left: window.innerWidth * 1.65,
        behavior: 'smooth',
      })

      setTimeout(() => {
        setIsFirstActive(false)
      }, 150)
    } else {
      document.getElementById('scrollElement').scrollTo({
        left: -window.innerWidth * 2,
        behavior: 'smooth',
      })
      setTimeout(() => {
        setIsFirstActive(true)
      }, 150)
    }
  }

  const modalStyles = {
    closeButton: {
      // display: 'none',
      color: 'white',
      fill: '#a1ff68',
      right: isMobile ? '0' : '-5%',
    },
    modal: {
      maxWidth: 'unset',
      width: isMobile ? '95vw' : '55vw',
      overflow: 'unset',
      left: '0',
      boxsizing: 'border-box',
      margin: isMobile ? 'auto' : 'unset',
      borderRadius: '30px',
    },
  }

  const ModalBg = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-items: center;
    background-color: #601c69;
    padding: 2% 5%;
    border-radius: 2rem;
  `

  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className={`standard`}
    >
      <SUB_container>
        <GenericRow
          width={'100%'}
          margin={isMobile ? '2% 3% 3% 1%' : '0'}
          justify={'space-between'}
        >
          {!isMobile && (
            <GenericLogo width={isMobile ? '50vw' : '15vw'} height={'9vh'} />
          )}
          {!isMobile && (
            <GenericTextSpan
              margin={isMobile ? '3% 0 0 0' : '7% 0 0 -5%'}
              fSize={'2rem'}
            >
              Wybierz opcje dla siebie
            </GenericTextSpan>
          )}
          <GenericRow
            className="pointer"
            onClick={() => history.goBack()}
            width={isMobile ? '100%' : '15%'}
            justify={'flex-end'}
          >
            <BsArrowLeftShort className="arrow-back" />{' '}
            {!isMobile && (
              <GenericTextSpan
                fSize={isMobile ? '1.7rem' : '1.5rem'}
                color={'#a1ff68'}
                className="pointer"
              >
                Wróć
              </GenericTextSpan>
            )}
          </GenericRow>
        </GenericRow>

        {isMobile && (
          <GenericRow>
            <GenericTextSpan margin={'2% 0 0 0'} fSize={'2rem'}>
              Wybierz opcje dla siebie
            </GenericTextSpan>
          </GenericRow>
        )}
        <GenericRow margin={isTablet && '0% 0 0 5%'}>
          {isMobile && mode == 'sub' && !isNutshell && (
            <div
              onClick={() => handleScrollToPart('first')}
              className={`sub-bookmark ${isFirstActive ? 'active' : ''}`}
            >
              <span>MIAZGA</span>
            </div>
          )}
          {isMobile && mode == 'sub' && !isNutshell && (
            <div
              onClick={() => handleScrollToPart('second')}
              className={`sub-bookmark ${!isFirstActive ? 'active' : ''}`}
            >
              <span>programy dodatkowe</span>
            </div>
          )}

          {isNutshell && (
            <Nutshell
              promoInfo={promoInfo}
              onSelectSubscription={onSelectSubscription}
              nutshellVersion={nutshellVersion ? nutshellVersion : ''}
            />
          )}

          {!isNutshell && (
            <GenericRow
              margin={isTablet ? '0 0 0 5%' : '0'}
              id="scrollElement"
              className="overflow"
              justify={'start'}
            >
              <GenericRow
                // id="scrollElement"
                width={isMobile ? '300vw' : '100%'}
                margin={
                  isMobile && !isTablet
                    ? '2% 0 0 5%'
                    : isTablet
                    ? '0% 0 0 0'
                    : '4% 0 0 0'
                }
                justify={
                  (mode && mode == 'Szpagat Turecki') ||
                  mode == 'MIAZGA w pigułce' ||
                  mode == 'MIAZGA w pigułce'
                    ? 'center'
                    : 'space-between'
                }
              >
                {/* first tile */}
                {mode != 'MIAZGA w pigułce' && mode != 'Szpagat Turecki' && (
                  <SUB_tile>
                    {!isMobile && (
                      <GenericRow width={'100%'} justify={'center'}>
                        <GenericTextSpan
                          fSize={'2rem'}
                          color={'#a1ff68'}
                          fWeight={'bold'}
                        >
                          MIAZGA
                        </GenericTextSpan>
                      </GenericRow>
                    )}

                    {/* {!isMobile && (
                    <GenericRow
                      width={'100%'}
                      margin={'1% 0 0 0'}
                      justify={'center'}
                    >
                      <GenericTextSpan fSize={'1rem'}>
                        Automatyczna, cykliczna płatność
                      </GenericTextSpan>
                    </GenericRow>
                  )} */}
                    {/* two sides - two subs */}
                    <GenericRow
                      width={'100%'}
                      justify={'space-between'}
                      margin={'1% 0 0 0'}
                    >
                      {/* left side */}
                      <GenericColumn
                        padding={'0 5%'}
                        width={isMobile ? '75vw' : '50%'}
                        className="right-border"
                      >
                        <GenericColumn height={'8vh'}>
                          <GenericTextSpan
                            tAlign={'left'}
                            width={'100%'}
                            display="block"
                            fSize={'1.8rem'}
                          >
                            MIAZGA
                          </GenericTextSpan>

                          <GenericTextSpan
                            margin={'3% 0 0 0'}
                            tAlign={'left'}
                            width={'100%'}
                            display="block"
                            fSize={'1rem'}
                          >
                            {(promoInfo &&
                              promoInfo.promo_status == 'PROMO_DIALOG') ||
                            (promoInfo &&
                              promoInfo.promo_status ==
                                'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
                              ? '1 miesiąc + 1'
                              : '1 miesiąc'}
                          </GenericTextSpan>
                        </GenericColumn>

                        <GenericTextSpan
                          margin={'3% 0 0 0'}
                          tAlign={'right'}
                          width={'100%'}
                          display="block"
                          fSize={'1.5rem'}
                          color={'#a1ff68'}
                        >
                          {/* {promoInfo &&
                            promoInfo.promo_status == 'PROMO_DIALOG' && (
                              <PromoInfo />
                            )} */}
                          zł
                          {((promoInfo &&
                            promoInfo.promo_status == 'PROMO_DIALOG') ||
                            (promoInfo &&
                              promoInfo.promo_status ==
                                'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')) && (
                            <GenericTextSpan
                              position="absolute"
                              right="25px"
                              top="5px"
                              color={'#a1ff68'}
                              fSize={'1.2rem'}
                              className="crossed"
                            >
                              {' '}
                              139,98
                            </GenericTextSpan>
                          )}
                        </GenericTextSpan>
                        <GenericTextSpan
                          margin={'3% 0 0 0'}
                          tAlign={'right'}
                          width={'100%'}
                          display="block"
                          fSize={'3rem'}
                          color={'#a1ff68'}
                        >
                          69,99
                        </GenericTextSpan>
                        <GenericRow
                          width={'70%'}
                          alignSelf={'end'}
                          color={'#a1ff68'}
                        >
                          <GenericTextSpan
                            fSize={'1rem'}
                            tAlign={'right'}
                            color={'#a1ff68'}
                          >
                            Automatyczna, cykliczna płatność
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow
                          justify="start"
                          margin={isMobile ? '15% 0 0 0' : '6% 0 0 0'}
                        >
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Treningi MIAZGA
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#601c69'}>
                            <BsX className="fill-white-icon" />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            MIAZGA w pigułce
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#601c69'}>
                            <BsX className="fill-white-icon" />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Wyzwanie szpagat
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Panel diety
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Kalkulator kalorii
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Plan picia wody
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Działy tematyczne
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Rozgrzewka, technika i rozciąganie
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow margin={'10% 0 '}>
                          <GenericTextSpan>
                            Zamawiam z obowiązkiem zapłaty.
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow margin={'0 0 10% 0'}>
                          <GenericButton
                            onClick={() => onSelectSubscription('one')}
                            justify={'center'}
                            className="standard"
                          >
                            Zamów
                          </GenericButton>
                        </GenericRow>
                      </GenericColumn>

                      {/* right side */}
                      <GenericColumn
                        padding={'0 5%'}
                        width={isMobile ? '75vw' : '50%'}
                        className="right-border"
                      >
                        <GenericColumn height={'8vh'}>
                          <GenericTextSpan
                            tAlign={'left'}
                            width={'100%'}
                            display="block"
                            fSize={'1.8rem'}
                          >
                            MIAZGA
                          </GenericTextSpan>

                          <GenericTextSpan
                            margin={'3% 0 0 0'}
                            tAlign={'left'}
                            width={'100%'}
                            display="block"
                            fSize={'1rem'}
                          >
                            {(promoInfo &&
                              promoInfo.promo_status == 'PROMO_DIALOG') ||
                            (promoInfo &&
                              promoInfo.promo_status ==
                                'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
                              ? '6 miesięcy'
                              : '3 miesiące'}
                          </GenericTextSpan>
                        </GenericColumn>

                        <GenericTextSpan
                          margin={'3% 0 0 0'}
                          tAlign={'right'}
                          width={'100%'}
                          display="block"
                          fSize={'1.5rem'}
                          color={'#a1ff68'}
                        >
                          {/* {promoInfo &&
                            promoInfo.promo_status == 'PROMO_DIALOG' && (
                              <PromoInfo />
                            )} */}
                          {((promoInfo &&
                            promoInfo.promo_status == 'PROMO_DIALOG') ||
                            (promoInfo &&
                              promoInfo.promo_status ==
                                'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')) && (
                            <GenericTextSpan
                              position="absolute"
                              right="25px"
                              top="5px"
                              color={'#a1ff68'}
                              fSize={'1.2rem'}
                              className="crossed"
                            >
                              {' '}
                              419,94
                            </GenericTextSpan>
                          )}
                          zł
                        </GenericTextSpan>
                        {(promoInfo &&
                          promoInfo.promo_status == 'PROMO_DIALOG') ||
                          (promoInfo &&
                            promoInfo.promo_status ==
                              'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')}
                        <GenericTextSpan
                          margin={'3% 0 0 0'}
                          tAlign={'right'}
                          width={'100%'}
                          display="block"
                          fSize={'3rem'}
                          color={'#a1ff68'}
                        >
                          {(promoInfo &&
                            promoInfo.promo_status == 'PROMO_DIALOG') ||
                          (promoInfo &&
                            promoInfo.promo_status ==
                              'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
                            ? '199,99'
                            : '179,99'}
                        </GenericTextSpan>
                        <GenericRow
                          width={'50%'}
                          alignSelf={'end'}
                          color={'#a1ff68'}
                        >
                          <GenericTextSpan
                            fSize={'1rem'}
                            tAlign={'right'}
                            color={'#a1ff68'}
                          >
                            {(promoInfo &&
                              promoInfo.promo_status == 'PROMO_DIALOG') ||
                            (promoInfo &&
                              promoInfo.promo_status ==
                                'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
                              ? 'Jednorazowa płatność'
                              : 'Automatyczna, cykliczna płatność'}
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow
                          justify="start"
                          margin={isMobile ? '15% 0 0 0' : '6% 0 0 0'}
                        >
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Treningi MIAZGA
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#601c69'}>
                            <BsX className="fill-white-icon" />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            MIAZGA w pigułce
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#601c69'}>
                            <BsX className="fill-white-icon" />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Wyzwanie szpagat
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Panel diety
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Kalkulator kalorii
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Plan picia wody
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Działy tematyczne
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Rozgrzewka, technika i rozciąganie
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow margin={'10% 0 '}>
                          <GenericTextSpan>
                            Zamawiam z obowiązkiem zapłaty.
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow margin={'0 0 10% 0'}>
                          <GenericButton
                            onClick={() =>
                              (promoInfo &&
                                promoInfo.promo_status == 'PROMO_DIALOG') ||
                              (promoInfo &&
                                promoInfo.promo_status ==
                                  'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
                                ? onSelectSubscription('old-three')
                                : onSelectSubscription('three')
                            }
                            justify={'center'}
                            className="standard"
                          >
                            Zamów
                          </GenericButton>
                        </GenericRow>
                      </GenericColumn>
                    </GenericRow>
                  </SUB_tile>
                )}

                {/* second tile */}
                <SUB_tile id={'secondTile'}>
                  {!isMobile && (
                    <GenericRow width={'100%'} justify={'center'}>
                      <GenericTextSpan
                        fSize={'2rem'}
                        color={'#a1ff68'}
                        fWeight={'bold'}
                      >
                        {mode == 'MIAZGA w pigułce' ||
                        mode == 'MIAZGA w pigułce'
                          ? 'MIAZGA w pigułce'
                          : mode == 'Szpagat Turecki'
                          ? 'Szpagat Turecki'
                          : 'Wyzwania & SZPAGAT'}
                      </GenericTextSpan>
                    </GenericRow>
                  )}

                  {/* {!isMobile && (
                  <GenericRow
                    width={'100%'}
                    margin={'1% 0 0 0'}
                    justify={'center'}
                  >
                    <GenericTextSpan fSize={'1rem'}>
                      Jednorazowa płatność
                    </GenericTextSpan>
                  </GenericRow>
                )} */}

                  {/* two sides - two subs */}
                  <GenericRow
                    width={'100%'}
                    justify={'space-between'}
                    margin={'1% 0 0 0'}
                  >
                    {/* left side */}
                    {((mode &&
                      (mode == 'WYZWANIE - TEST' ||
                        mode == 'MIAZGA w pigułce')) ||
                      mode == 'sub') && (
                      <GenericColumn
                        padding={'0 5%'}
                        width={
                          isMobile
                            ? '75vw'
                            : mode == 'WYZWANIE - TEST' ||
                              mode == 'MIAZGA w pigułce'
                            ? '100%'
                            : '50%'
                        }
                        className={
                          mode &&
                          (mode == 'WYZWANIE - TEST' ||
                            mode == 'MIAZGA w pigułce')
                            ? ''
                            : 'right-border'
                        }
                      >
                        <GenericColumn height={'8vh'}>
                          {isInfoOpen && (
                            <div className="miazga-nutshell-info">
                              <GenericCloseButton
                                className="promo-modal-close-btn info"
                                width={'14px'}
                                height={'14px'}
                                onClick={() => setInfoOpen(false)}
                              />
                              Pakiet zawiera 60 treningów. Dostęp na 3 miesiące
                              od momentu aktywacji
                            </div>
                          )}
                          <GenericTextSpan
                            tAlign={'left'}
                            width={'100%'}
                            display="block"
                            fSize={'1.8rem'}
                          >
                            {(promoInfo &&
                              promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
                            (promoInfo &&
                              promoInfo.promo_status ==
                                'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
                              ? 'MIAZGA w pigułce'
                              : 'MIAZGA w pigułce vol. 1'}
                            {/* <div className="new-badge">
                              <span>Nowość</span>
                            </div> */}
                            <AiOutlineInfoCircle
                              onClick={() => setInfoOpen(true)}
                              className="miazga-info"
                            />
                          </GenericTextSpan>

                          <GenericTextSpan
                            margin={'3% 0 0 0'}
                            tAlign={'left'}
                            width={'100%'}
                            display="block"
                            fSize={'1rem'}
                          >
                            3 miesiące
                          </GenericTextSpan>
                        </GenericColumn>

                        <GenericTextSpan
                          margin={'3% 0 0 0'}
                          tAlign={'right'}
                          width={'100%'}
                          display="block"
                          fSize={'1.5rem'}
                          color={'#a1ff68'}
                        >
                          {/* {(promoInfo &&
                            promoInfo.promo_status == 'PROMO_DIALOG') ||
                            (promoInfo &&
                              promoInfo.promo_status == 'MIAZGA_NUTSHELL' && (
                                <PromoInfo />
                              ))} */}
                          {((promoInfo &&
                            promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
                            (promoInfo &&
                              promoInfo.promo_status ==
                                'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')) && (
                            <GenericTextSpan
                              position="absolute"
                              right="25px"
                              top="5px"
                              color={'#a1ff68'}
                              fSize={'1.2rem'}
                              className="crossed"
                            >
                              {' '}
                              249,99
                            </GenericTextSpan>
                          )}
                          zł
                        </GenericTextSpan>
                        <GenericTextSpan
                          margin={'3% 0 0 0'}
                          tAlign={'right'}
                          width={'100%'}
                          display="block"
                          fSize={'3rem'}
                          color={'#a1ff68'}
                        >
                          {(promoInfo &&
                            promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
                          (promoInfo &&
                            promoInfo.promo_status ==
                              'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
                            ? '149,99'
                            : '249,99'}
                        </GenericTextSpan>
                        <GenericRow
                          width={'50%'}
                          alignSelf={'end'}
                          color={'#a1ff68'}
                        >
                          <GenericTextSpan
                            fSize={'1rem'}
                            tAlign={'right'}
                            color={'#a1ff68'}
                          >
                            Jednorazowa płatność
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow
                          justify="start"
                          margin={isMobile ? '15% 0 0 0' : '6% 0 0 0'}
                        >
                          <SUB_ball color={'#601c69'}>
                            <BsX className="fill-white-icon" />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Treningi MIAZGA
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            {(promoInfo &&
                              promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
                            (promoInfo &&
                              promoInfo.promo_status ==
                                'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
                              ? 'MIAZGA w pigułce'
                              : 'MIAZGA w pigułce vol. 1'}
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#601c69'}>
                            <BsX className="fill-white-icon" />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Wyzwanie szpagat
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Panel diety
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Kalkulator kalorii
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Plan picia wody
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#601c69'}>
                            <BsX className="fill-white-icon" />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Działy tematyczne
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Rozgrzewka, technika i rozciąganie
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow margin={'10% 0 '}>
                          <GenericTextSpan>
                            Zamawiam z obowiązkiem zapłaty.
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow margin={'0 0 10% 0'}>
                          <GenericButton
                            onClick={
                              (promoInfo &&
                                promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
                              (promoInfo &&
                                promoInfo.promo_status ==
                                  'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
                                ? history.push({
                                    pathname: '/wybierz-plan/sub',
                                    state: { mode: 'w-pigulce' },
                                  })
                                : () => onSelectSubscription('nutshell1')
                              // : onSelectSubscription('nutshell')
                            }
                            justify={'center'}
                            className="standard"
                          >
                            {(promoInfo &&
                              promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
                            (promoInfo &&
                              promoInfo.promo_status ==
                                'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
                              ? 'Wybierz opcję'
                              : 'Zamów'}
                          </GenericButton>
                        </GenericRow>
                      </GenericColumn>
                    )}

                    {/* right side */}
                    {((mode && mode == 'Szpagat Turecki') || mode == 'sub') && (
                      <GenericColumn
                        padding={'0 5%'}
                        width={
                          isMobile
                            ? '75vw'
                            : mode == 'Szpagat Turecki'
                            ? '100%'
                            : '50%'
                        }
                      >
                        <GenericColumn height={'8vh'}>
                          <GenericTextSpan
                            tAlign={'left'}
                            width={'100%'}
                            display="block"
                            fSize={'1.8rem'}
                          >
                            Dostęp SZPAGAT
                          </GenericTextSpan>

                          <GenericTextSpan
                            margin={'3% 0 0 0'}
                            tAlign={'left'}
                            width={'100%'}
                            display="block"
                            fSize={'1rem'}
                          >
                            Dożywotnio
                          </GenericTextSpan>
                        </GenericColumn>

                        <GenericTextSpan
                          margin={'3% 0 0 0'}
                          tAlign={'right'}
                          width={'100%'}
                          display="block"
                          fSize={'1.5rem'}
                          color={'#a1ff68'}
                        >
                          zł
                        </GenericTextSpan>
                        <GenericTextSpan
                          margin={'3% 0 0 0'}
                          tAlign={'right'}
                          width={'100%'}
                          display="block"
                          fSize={'3rem'}
                          color={'#a1ff68'}
                        >
                          89,99
                        </GenericTextSpan>
                        <GenericRow
                          width={'50%'}
                          alignSelf={'end'}
                          color={'#a1ff68'}
                        >
                          <GenericTextSpan
                            fSize={'1rem'}
                            tAlign={'right'}
                            color={'#a1ff68'}
                          >
                            Jednorazowa płatność
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow
                          justify="start"
                          margin={isMobile ? '15% 0 0 0' : '6% 0 0 0'}
                        >
                          <SUB_ball color={'#601c69'}>
                            <BsX className="fill-white-icon" />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Treningi MIAZGA
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#601c69'}>
                            <BsX className="fill-white-icon" />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            MIAZGA w pigułce
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Wyzwanie szpagat
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Panel diety
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Kalkulator kalorii
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#a1ff68'}>
                            <BsCheck />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Plan picia wody
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#601c69'}>
                            <BsX className="fill-white-icon" />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Działy tematyczne
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify="start" margin={'3% 0 0 0'}>
                          <SUB_ball color={'#601c69'}>
                            <BsX className="fill-white-icon" />
                          </SUB_ball>
                          <GenericTextSpan tAlign="left" margin={'0 0 0 4%'}>
                            Rozgrzewka, technika i rozciąganie
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow margin={'10% 0 '}>
                          <GenericTextSpan>
                            Zamawiam z obowiązkiem zapłaty.
                          </GenericTextSpan>
                        </GenericRow>

                        <GenericRow margin={'0 0 10% 0'}>
                          <GenericButton
                            onClick={() =>
                              onSelectSubscription('turecki', 'Szpagat Turecki')
                            }
                            justify={'center'}
                            className="standard"
                          >
                            Zamów
                          </GenericButton>
                        </GenericRow>
                      </GenericColumn>
                    )}
                  </GenericRow>
                </SUB_tile>
              </GenericRow>
            </GenericRow>
          )}
        </GenericRow>

        <GenericRow flexDir={isMobile ? 'column' : 'row'}>
          <GenericRow width={'90%'} justify="center" margin={'0% auto 2% auto'}>
            <GenericCheckbox
              textSize={'1rem'}
              regulations
              name={'regulations-checkbox'}
              defaultChecked={false}
              isCheckboxChecked={isUserCheckedLegalRegulationsChheckbox}
              checkCheckbox={(e: any) => onCheckLegalCheckbox(e)}
              text={``}
              checkboxStyle={{}}
              textMargin={{}}
              containerStyle={{
                margin: '3% 0 0 1.5%',
                justify: 'center',
              }}
            />
          </GenericRow>
          <AvailablePaymentMethods>
            <GenericTextSpan width={'35%'} display={'block'}>
              Dostępne metody płatności:
            </GenericTextSpan>
            <PaymentMethodIcon src={visaIcon}></PaymentMethodIcon>
            <PaymentMethodIcon src={masterCardIcon}></PaymentMethodIcon>
            <PaymentMethodIcon src={americanExpressIcon}></PaymentMethodIcon>
            {/* <PaymentMethodIcon google src={googlePayIcon}></PaymentMethodIcon>
          <PaymentMethodIcon src={przelewy24Icon} przelewy></PaymentMethodIcon> */}
          </AvailablePaymentMethods>
        </GenericRow>
        <GenericRow
          className="sub"
          width={isMobile ? '95%' : '60%'}
          justify="center"
          padding={'5% 0'}
          margin={'0% auto 2% auto'}
          onClick={handleTryApp}
        >
          <GenericTextSpan
            fWeight={'bold'}
            fSize={'1.2rem'}
            margin={'0 4px 0 0'}
          >
            Przejdź do
          </GenericTextSpan>{' '}
          <GenericTextSpan
            fWeight={'bold'}
            color={'#a1ff68'}
            fSize={'1.2rem'}
            margin={'0 4px 0 0'}
          >
            darmowej
          </GenericTextSpan>{' '}
          <GenericTextSpan fWeight={'bold'} fSize={'1.2rem'}>
            wersji aplikacji
          </GenericTextSpan>
        </GenericRow>
      </SUB_container>

      <Modal
        open={isModalOpen}
        animationDuration={700}
        onClose={() => setModalOpen(false)}
        center
        styles={modalStyles}
      >
        <ModalBg>
          <GenericRow margin={'2% auto'} width={isMobile ? '80%' : '100%'}>
            <GenericTextSpan color="white" fSize={'2rem'} fWeight="bold">
              Wybierz program MIAZGA w pigułce
            </GenericTextSpan>
          </GenericRow>
          <GenericCard
            onClick={() => onSelectSubscription('nutshell')}
            flexDir={'row'}
            className="standard"
            width={'90%'}
            margin={isMobile ? '5% auto' : '2% auto'}
            padding={'2% 3%'}
          >
            <GenericRow
              justify="start"
              width={isMobile ? '66%' : '50%'}
              padding={isMobile ? '1%' : 'unset'}
            >
              <GenericTextSpan
                color="white"
                tAlign={isMobile ? 'left' : 'unset'}
                fSize={isMobile ? '1.6rem' : '1.9rem'}
                fWeight="bold"
              >
                MIAZGA w pigułce vol 1
              </GenericTextSpan>
            </GenericRow>
            <GenericRow width={isMobile ? '33%' : '50%'}>
              {promoInfo && promoInfo.promo_status == 'MIAZGA_NUTSHELL' && (
                <GenericTextSpan
                  position="absolute"
                  right="1px"
                  top={isMobile ? '-15px' : '1px'}
                  color={'#a1ff68'}
                  fSize={'1.2rem'}
                  className="crossed"
                >
                  {' '}
                  249,99 zł
                </GenericTextSpan>
              )}
              <GenericTextSpan
                margin={'3% 0 0 0'}
                tAlign={'right'}
                width={'100%'}
                display="block"
                fSize={isMobile ? '1.5rem' : '3rem'}
                color={'#a1ff68'}
              >
                {promoInfo && promoInfo.promo_status == 'MIAZGA_NUTSHELL'
                  ? '149,99 zł'
                  : '249,99 zł'}
              </GenericTextSpan>
            </GenericRow>
          </GenericCard>

          <GenericCard
            flexDir={'row'}
            className="standard"
            width={'90%'}
            margin={isMobile ? '5% auto' : '2% auto'}
            padding={'2% 3%'}
          >
            <GenericRow
              align="start"
              flexDir="column"
              width={isMobile ? '66%' : '50%'}
              padding={isMobile ? '1%' : 'unset'}
            >
              <GenericTextSpan
                color="white"
                tAlign={isMobile ? 'left' : 'unset'}
                fSize={isMobile ? '1.6rem' : '1.9rem'}
                fWeight="bold"
              >
                MIAZGA w pigułce vol 2
              </GenericTextSpan>
            </GenericRow>
            <GenericRow width={isMobile ? '33%' : '50%'}>
              {promoInfo && promoInfo.promo_status == 'MIAZGA_NUTSHELL' && (
                <GenericTextSpan
                  position="absolute"
                  right="1px"
                  top={isMobile ? '-15px' : '1px'}
                  color={'#a1ff68'}
                  fSize={'1.2rem'}
                  className="crossed"
                >
                  {' '}
                  249,99 zł
                </GenericTextSpan>
              )}
              <GenericTextSpan
                margin={'3% 0 0 0'}
                tAlign={'right'}
                width={'100%'}
                display="block"
                fSize={isMobile ? '1.5rem' : '3rem'}
                color={'#a1ff68'}
              >
                {promoInfo && promoInfo.promo_status == 'MIAZGA_NUTSHELL'
                  ? '149,99 zł'
                  : '249,99 zł'}
              </GenericTextSpan>
            </GenericRow>
          </GenericCard>

          <GenericRow>
            <GenericRow flexDir={isMobile ? 'column' : 'row'}>
              <GenericRow
                width={'100%'}
                justify="center"
                margin={'0% auto 2% auto'}
              >
                <GenericCheckbox
                  textSize={'1rem'}
                  regulations
                  name={'regulations-checkbox'}
                  defaultChecked={false}
                  isCheckboxChecked={isUserCheckedLegalRegulationsChheckbox}
                  checkCheckbox={(e: any) => onCheckLegalCheckbox(e)}
                  text={``}
                  checkboxStyle={{}}
                  textMargin={{}}
                  containerStyle={{
                    margin: '3% 0 0 1.5%',
                    justify: 'center',
                  }}
                />
              </GenericRow>
              <AvailablePaymentMethods>
                <GenericTextSpan width={'35%'} display={'block'}>
                  Dostępne metody płatności:
                </GenericTextSpan>
                <PaymentMethodIcon src={visaIcon}></PaymentMethodIcon>
                <PaymentMethodIcon src={masterCardIcon}></PaymentMethodIcon>
                <PaymentMethodIcon
                  src={americanExpressIcon}
                ></PaymentMethodIcon>
                {/* <PaymentMethodIcon google src={googlePayIcon}></PaymentMethodIcon>
          <PaymentMethodIcon src={przelewy24Icon} przelewy></PaymentMethodIcon> */}
              </AvailablePaymentMethods>
            </GenericRow>
          </GenericRow>
        </ModalBg>
      </Modal>
    </GenericBackgroundLayer>
  )
}

export default SelectSub
